import AbstractModule from './AbstractModule';

import {selectricDecorator} from '../ractive/ractive-decorators-selectric';
import tap from '../ractive/ractive-events-tap';
import fade from '../ractive/ractive-transitions-fade';

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.fetchingTemplate = false;
        this.template = false;
        this.partials = false;

        this.gender = options.gender;

        this.init();
    }

    init() {
        // Prepare template on init.
        this.fetchTemplate();

        this.$document.on('update.EventList', (ev, filters) => {
            if (filters) {
                this.setEventsFromFilters(filters);
            }
        });
    }

    eventsLoaded() {
        if (!this.calendarEvents) {
            return this;
        }

        if (!this.ractiveInstance) {
            this.initRactive();
            return this;
        }

        this.ractiveInstance.set('calendarEvents', this.calendarEvents);
        return this;
    }

    /**
     * Inits ractive and set calendar events if already specified.
     * @return {[type]} [description]
     */
    initRactive() {
        if (!this.template && !this.fetchingTemplate) {
            this.fetchTemplate(() => { this.initRactive() });
            return this;
        }

        let data = {
            calendarEvents: [],
            loading    : true
        };
        if (this.calendarEvents) {
            data = {
                calendarEvents : this.calendarEvents,
                loading : false
            }
        }
        let domList = this.$el;
        this.ractiveInstance = new Ractive({
            el         : domList,
            template   : this.template,
            partials   : this.partials,
            events     : {tap},
            transitions: {fade},
            decorators : {
                selectric: selectricDecorator
            },

            data    : data,
            onrender: () => {
                // self.loaded();
            }
        });
    }

    /**
     * Filters gender, fromDate, toDate
     * @param {[type]} filters [description]
     */
    setEventsFromFilters(opts) {
        let gender = opts.gender || this.gender;
        let fromDate = opts.fromDate || false;
        let toDate = opts.toDate || false;

        if (!gender || !fromDate || !toDate) {
            // Missing informations...
            return false;
        }

        let data = {
            gender : gender,
            to_date : toDate,
            from_date: fromDate
        }

        this.fetchEvents(data);
        return this;
    }

    /**
     * From date to date with gender
     * @param  {[type]} opts [description]
     * @return {[type]}      [description]
     */
    fetchEvents(data) {

        $.get('events', data, (response) => {
            if (response.success) {
                this.calendarEvents = response.events;
                this.eventsLoaded();
            } else {
                this.error(response);
            }
        }, 'json')
    }

    /**
     * Get the required template for the list.
     * @param  {Function} cb [description]
     * @return {[type]}      [description]
     */
    fetchTemplate(cb) {
        if (this.fetchingTemplate || this.template) {
            return this;
        }

        this.fetchingTemplate = true;

        $.get('template', {template: 'volleyball/template/partial/components/card/card-match-volleyball-with-feedback'}, (response) => {
            if (response.success) {
                this.template = response.template;
                this.partials = response.partials;
                if (typeof cb === 'function') {
                    cb();
                }
            }
            this.fetchingTemplate = false;
        }, 'json');

        return this;
    }

    /**
     * Toggle loading styles
     * @return {[type]} [description]
     */
    loading() {
        if (this.ractiveInstance) {
            this.ractiveInstance.set('loading', true);
        }
    }

    /**
     * Toggle loaded style (when loading is done.)
     * @return {[type]} [description]
     */
    loaded() {
        if (this.ractiveInstance) {
            this.ractiveInstance.set('loading', false);
        }
    }

    /**
     * An error occured with some ajax call.
     * @param  {[type]} response [description]
     * @return {[type]}          [description]
     */
    error(response) {
        // An error occured...
        console.debug(response);
    }

    destroy() {
        this.$document.off('.EventList');
        this.$el.off('.EventList');
    }
}
